import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { parcelShowcase } from "../lib/api";

const GREEN_DARK = "#04392B";
const GOLD = "#E8B10A";

// Bandeau "communiqué" premium, une seule ligne, défilement continu (marquee).
// Affiche les transports entre particuliers à prendre pour inciter tout le monde à
// utiliser / rejoindre le service. Toujours à la même place, identique de page en page.
export default function TransportTicker() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    let on = true;
    const load = () => parcelShowcase().then((d) => { if (on) setItems(Array.isArray(d) ? d : []); }).catch(() => {});
    load();
    const id = setInterval(load, 30000);
    return () => { on = false; clearInterval(id); };
  }, []);

  const msgs = items.length > 0
    ? items.map((p) => `🚚 ${p.pickup_zone} → ${p.dropoff_zone} · CHF ${Number(p.price_chf || 0).toFixed(0)} · ${p.service === "express" ? "Express" : "Programmé"}`)
    : ["🚚 Gagnez de l'argent en livrant près de chez vous — devenez livreur La BASE", "📦 Un colis à envoyer ? Confiez-le à un particulier de confiance"];

  // Contenu dupliqué pour une boucle sans couture.
  const loop = [...msgs, ...msgs];

  return (
    <button
      type="button"
      data-testid="transport-ticker"
      onClick={() => nav("/services/colis")}
      className="w-full overflow-hidden flex items-center"
      style={{ background: GREEN_DARK, height: 34, borderBottom: `1px solid rgba(232,177,10,0.35)` }}
      aria-label="Transports entre particuliers à prendre"
    >
      <span className="shrink-0 px-3 h-full flex items-center text-[11px] font-extrabold uppercase tracking-wide"
        style={{ background: GOLD, color: GREEN_DARK }}>Transport</span>
      <div className="relative flex-1 overflow-hidden h-full">
        <div className="absolute whitespace-nowrap flex items-center h-full"
          style={{ animation: `lb-marquee ${Math.max(18, loop.length * 4)}s linear infinite` }}>
          {loop.map((m, i) => (
            <span key={i} className="px-6 text-[13px] font-semibold" style={{ color: "#F3F7F5" }}>{m}</span>
          ))}
        </div>
      </div>
    </button>
  );
}
